<template>
   <div :class="typeClass" class="notification" :style="customWidth">
      <i class="icon icon-cancel text-black" @click="removeNotification({ notification: notification })"></i>
      <span v-html="notification.message"></span>
   </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
   components: {},

   props: {
      notification: {
         type: Object,
      },
   },

   data() {
      return {
         timeout: null,
      };
   },

   created() {
      this.timeout = setTimeout(() => {
         this.removeNotification({ notification: this.notification });
      }, this.notification.duration);
   },

   mounted() {},

   computed: {
      typeClass() {
         return `notification-${this.notification.type}`;
      },
      customWidth() {
         if (this.notification.customWidth) {
            return 'width:' + this.notification.customWidth;
         }
         return;
      },
   },

   watch: {},

   methods: {
      ...mapActions(['removeNotification']),
   },
   beforeDestroy() {
      clearTimeout(this.timeout);
   },
};
</script>

<style lang="scss" scoped>
.notification {
   background: #ffffff;
   padding: 1rem;
   width: 200px;
   border-radius: 4px;
   box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);
   margin-top: 0.6rem;
   position: relative;
   text-align: left;
   &-succes {
      border-left: 5px solid #0cd0f0;
   }
   &-error {
      border-left: 5px solid #c0392c;
   }
   &-info {
      border-left: 5px solid #666;
   }
   .icon-cancel {
      position: absolute;
      right: 0.8rem;
      top: 0.8rem;
      font-size: 0.6rem;
      font-weight: bolder;
      color: #555;
      cursor: pointer;
   }
}
</style>
